import React from "react";

import AccountStatementPagerButton from "./AccountStatementPagerButton";

type AccountStatementPagerButtonProps = {
	disabled?: boolean;
	page: number;
	active?: boolean;
	children?: JSX.Element | JSX.Element | string | number;
	onPageChange: (newPage: number) => void;
};

export default function PageButton(
	props: AccountStatementPagerButtonProps & { page: number }
) {
	return (
		<AccountStatementPagerButton {...props}>
			{props.page}
		</AccountStatementPagerButton>
	);
}
